/**
 * Makes the gallery zoom "+" chip follow the pointer across each zoomable
 * image, so it reads as a custom cursor (the image hides the OS cursor via
 * `cursor: none`). It writes the pointer position into `--zoom-cursor-x/y` on
 * the hovered `.product-media-container__zoom-button`; CSS positions the chip
 * from those vars.
 *
 * Delegated on the document so it survives gallery re-renders (variant swaps),
 * rAF-throttled, and a no-op for touch (no hover affordance there).
 */
const ZOOM_BUTTON_SELECTOR = '.product-media-container__zoom-button';

let pending = null;
let frameId = null;

function flush() {
  frameId = null;
  const next = pending;
  pending = null;
  if (!next) return;

  const rect = next.button.getBoundingClientRect();
  next.button.style.setProperty('--zoom-cursor-x', `${next.clientX - rect.left}px`);
  next.button.style.setProperty('--zoom-cursor-y', `${next.clientY - rect.top}px`);
}

document.addEventListener(
  'pointermove',
  (event) => {
    // Mouse / pen only — touch has no hover affordance.
    if (event.pointerType === 'touch') return;

    const target = event.target;
    const button = target instanceof Element ? target.closest(ZOOM_BUTTON_SELECTOR) : null;
    if (!button) return;

    pending = { button, clientX: event.clientX, clientY: event.clientY };
    if (frameId === null) frameId = requestAnimationFrame(flush);
  },
  { passive: true }
);
